import { render } from "./EntryTypePill.vue?vue&type=template&id=0f5a2a73"
import script from "./EntryTypePill.vue?vue&type=script&lang=js"
export * from "./EntryTypePill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__